import type { PortalTypeOption, DateFilterOption, SortOption } from './types';

export const PORTAL_TYPES: PortalTypeOption[] = [
  { id: 'portal_type_document', value: 'Document', label: 'Página' },
  { id: 'portal_type_file', value: 'File', label: 'Arquivo' },
  { id: 'portal_type_link', value: 'Link', label: 'Link' },
  { id: 'portal_type_noticia', value: 'News', label: 'Notícia' },
  { id: 'portal_type_unidade', value: 'unidade', label: 'Unidade' },
];

export const getDateFilterOptions = (): DateFilterOption[] => {
  const today = new Date();
  const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
  const lastWeek = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
  const lastMonth = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);

  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  };

  return [
    {
      id: 'query-date-yesterday',
      value: formatDate(yesterday),
      label: 'Ontem',
    },
    {
      id: 'query-date-lastweek',
      value: formatDate(lastWeek),
      label: 'Última semana',
    },
    {
      id: 'query-date-lastmonth',
      value: formatDate(lastMonth),
      label: 'Último mês',
    },
    {
      id: 'query-date-ever',
      value: '1970-01-02',
      label: 'Sempre',
    },
  ];
};

export const SORT_OPTIONS: SortOption[] = [
  { id: 'sort-relevance', value: 'relevance', label: 'relevância' },
  {
    id: 'sort-date',
    value: 'effective',
    label: 'data (mais recente primeiro)',
    order: 'reverse',
  },
  { id: 'sort-title', value: 'sortable_title', label: 'alfabeticamente' },
];

export const DEFAULT_PORTAL_TYPES = PORTAL_TYPES.map((type) => type.value);
